import { ChangeDetectionStrategy, Component } from "@angular/core";
import { S25InfoMessageModule } from "../../s25-info-message/s25.info.message.module";
import { FORM_USE_COMBINED_VISIBILITY_HELP, FORM_USE_VISIBILITY_HELP } from "../data.ingestion.const";

@Component({
    selector: "s25-ng-ingestion-form-use-help",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25InfoMessageModule],
    template: `
        <s25-ng-info-message [isPopover]="true" [customLabel]="'Form use'">
            <ul class="form-use-help-list">
                @for (useHelp of formUseVisibilityHelp; track useHelp.label) {
                    <li>
                        <strong>{{ useHelp.label }}:</strong> {{ useHelp.description }}
                    </li>
                }
            </ul>
            <p class="form-use-help-combined">{{ combinedVisibilityHelp }}</p>
        </s25-ng-info-message>
    `,
    styles: `
        :host {
            display: inline-block;
        }

        .form-use-help-list {
            margin: 0;
            padding-left: 1.25rem;
        }

        .form-use-help-combined {
            margin: 0.5rem 0 0;
        }
    `,
})
export class IngestionFormUseHelpComponent {
    readonly formUseVisibilityHelp = FORM_USE_VISIBILITY_HELP;
    readonly combinedVisibilityHelp = FORM_USE_COMBINED_VISIBILITY_HELP;
}
